import { render, staticRenderFns } from "./StudipAssetImg.vue?vue&type=template&id=d96e8b2e&"
import script from "./StudipAssetImg.vue?vue&type=script&lang=js&"
export * from "./StudipAssetImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports